import { Link } from '@cian/ui-kit/link';
import { Body2, UIHeading4 } from '@cian/ui-kit/typography';

import type { ICategoryOffer, TOffersDealType } from 'shared/types/buildingOffers';
import { getOfferPreview } from 'shared/utils/buildingOffers';

import { OfferContacts } from './components/OfferContacts';
import { OfferGallery } from './components/OfferGallery';

import style from './style.css';

export interface IOfferPreviewProps {
  offer: ICategoryOffer;
  dealType: TOffersDealType;
  /** Имя представителя для контактов — только на вкладке «От официального представителя» */
  representativeName: string | null;
}

/** Превью выбранного объявления (`offer_preview.tsx` монолита) */
export const OfferPreview = ({ offer, dealType, representativeName }: IOfferPreviewProps) => {
  const { title, occupancy, price, pricePerMeter, props } = getOfferPreview(offer, dealType);

  return (
    <div className={style['container']} data-name="OfferPreview">
      <OfferGallery photos={offer.photos} alt={title} />
      <div className={style['details']}>
        <div className={style['info']}>
          <div>
            <Body2 fontWeight="bold">
              {title}
              {occupancy && (
                <>
                  {' '}
                  <span className={occupancy.isOccupied ? style['occupied'] : style['free']}>{occupancy.text}</span>
                </>
              )}
            </Body2>
            {price && <UIHeading4 as="strong">{price}</UIHeading4>}
            {pricePerMeter && <Body2>{pricePerMeter}</Body2>}
          </div>
          {props.length > 0 && (
            <dl className={style['props']}>
              {props.map(({ name, value, isImportant }) => (
                <div key={name} className={style['prop']}>
                  <dt>
                    <Body2 fontWeight={isImportant ? 'bold' : undefined}>{name}</Body2>
                  </dt>
                  <dd className={style['value']}>
                    <Body2 fontWeight={isImportant ? 'bold' : undefined}>{value}</Body2>
                  </dd>
                </div>
              ))}
            </dl>
          )}
          <Link href={offer.url} target="_blank" fontSize="S" data-name="OfferLink">
            Подробнее
          </Link>
        </div>
        {/* key: при смене объявления телефоны снова скрыты */}
        <OfferContacts key={offer.cianId} name={representativeName} phones={offer.phones} />
      </div>
    </div>
  );
};
